import type { ApiCatalogDetail } from '@chatsdet/types';
import { formatJsonDisplay } from '../../../ui/components/api-catalog/JsonBlock';
import { CodePanel, type CodeTab } from '../../../ui/components/api-catalog/CodePanel';
import {
  DrawerSectionLabel,
  HeadersTable,
  StatusCodeTable,
} from '../../../ui/components/api-catalog/DrawerTables';

type ResponseTabPanelProps = {
  detail: ApiCatalogDetail;
};

export function ResponseTabPanel({ detail }: ResponseTabPanelProps) {
  const sampleText = formatJsonDisplay(detail.responseSample);
  const schemaText = formatJsonDisplay(detail.responseSchema);
  const responseHeaders = detail.latestOccurrence?.responseHeaders ?? null;

  const bodyTabs: CodeTab[] = [
    {
      id: 'sample',
      label: 'Sample',
      content: sampleText,
      language: 'json',
      emptyText: 'No response sample captured.',
    },
    {
      id: 'schema',
      label: 'Schema',
      content: schemaText,
      language: 'json',
      emptyText: 'No response schema inferred yet.',
    },
  ];

  return (
    <div className="px-6 pt-4 pb-6 space-y-6">
      {/* Observed status codes */}
      <div>
        <div className="mb-2.5">
          <DrawerSectionLabel>Status codes</DrawerSectionLabel>
        </div>
        <StatusCodeTable occurrences={detail.recentOccurrences} />
      </div>

      {/* Response headers — from the most recent observed call */}
      <div>
        <div className="mb-2.5">
          <DrawerSectionLabel
            count={responseHeaders ? Object.keys(responseHeaders).length : undefined}
          >
            Response headers
          </DrawerSectionLabel>
        </div>
        <HeadersTable
          headers={responseHeaders}
          emptyText="No response headers captured on the latest call."
        />
      </div>

      {/* Body — segmented code viewer */}
      <div>
        <div className="mb-2.5">
          <DrawerSectionLabel>Body</DrawerSectionLabel>
        </div>
        <CodePanel tabs={bodyTabs} contentTypeLabel="application/json" />
      </div>
    </div>
  );
}
